import log from "loglevel";
import React, { Component } from "react";
import { Link, useLocation } from "react-router-dom";
import * as constants from "Constants";
import httpService from "services/httpService";
import { Button } from "react-bootstrap";
import { MdImportExport } from "react-icons/md";
import dragula from "dragula"
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { IoAddCircleOutline } from "react-icons/io5";

const NavItem = ({ to, state, children, pageID, className, as = "Link", }) => {
  const location = useLocation();
  const isActive = location.pathname.includes((typeof to === 'object' ? to.pathname : to));
  return (
    <li pageID={pageID} className={`link-item ${isActive ? 'active' : ''} level-2`}>
      {
        as === "anchor" ? <a href={to} className="link">
          <div className={`${isActive ? 'selectedLink' : ''} d-flex link-div link`}>
            {children}
          </div>
        </a> : <Link className="link" to={to}>
          <div className={`${isActive ? 'selectedLink' : ''} d-flex link-div link`}>
            {children}
          </div>
        </Link> 
      }

    </li>
  );
};

export default class SideBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // selectedItem: null, // Initialize selected item to null
      pending_students: "0",
      activeLink: "",
      // title: [],
      // descriptions: [],
      // isDeleted: false,
      // pageAdded: false,
    };
  }



  pending_students = () => {
    // let url = '/courseware/api/course/'+ this.props.routeProps.match.params.courseId +'/new_pending_students';
    // fetch(url)
    // .then((result) => result.json())
    // .then((result) => {
    //     this.setState({pending_students:result.new_pending_students});
    //     log.log(result.new_pending_students, "New sidebar")
    // })
    //log.log(this.props.routeProps.match.params.courseId, "sidebar");
  };

  componentDidMount = () => {
    this.pending_students();
    this.setState({ activeLink: window.location.pathname });
    // let url = constants.base_url + "/courseware/api/course/" + this.props.routeProps.match.params.courseId + "/pages/";
    // httpService
    //   .get(url, {
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //   })
    //   .then((res) => {
    //     this.setState({ title: res.data, descriptions: res.data });
    //   })
    //   .catch((err) => {
    //   });
    // this.listItems = document.querySelectorAll('#sideList > li.link-item,  #sideList> div#additionalPages> li.link-item');
    // this.listItems.forEach(item => {
    //   item.addEventListener('click', this.handleItemClick);
    // });
  };
  // Cleaning activity by removing event listeners
  // componentWillUnmount() {
  //   this.listItems.forEach(item => {
  //       item.removeEventListener('click', this.handleItemClick);
  //   });
  // }

  // handleItemClick = (event) => {
  //   // // Remove selected class from all items
  //   // this.listItems.forEach(li => li.classList.remove('selected'));

  //   // // Add selected class to the clicked item
  //   // event.currentTarget.classList.add('selected');
  //   if(this.state.selectedItem != null) {
  //     this.state.selectedItem.classList.remove('selected');
  //   }
  //   event.currentTarget.classList.add('selected');
  //   this.setState({selectedItem:event.currentTarget});
  // }


  componentDidUpdate(prevProps) {
    const { activeLink } = this.state;
    if (window.location.pathname !== activeLink) {
      this.setState({ activeLink: window.location.pathname });
    }
  }
  handleAddionalPageReorder = pages => {
    log.log(pages)
    if (!this.state.order) {
      let tempPagesCopy = [...pages];
      let tempIdToPage = {};
      pages.forEach((page) => {
        tempIdToPage[page.id] = page;
      });
      let drag = dragula(
        [document.getElementById("additionalPages")],
        {
          revertOnSpill: true,
        }
      ).on(
        "drop",
        function (el, container, handle) {
          log.log(container.children)
          tempPagesCopy = Array.from(container.children).map(
            function (list) {
              return tempIdToPage[list.attributes.pageID.nodeValue];
            }.bind(this)
          );
          log.log(tempPagesCopy)
          this.setState({ idToPage: tempIdToPage, pagesCopy: tempPagesCopy });
        }.bind(this)
      );
      this.setState({ pageDragulaService: drag, order: true })
    } else {
      this.state.pageDragulaService.destroy();
      if (this.state.pagesCopy && this.state.pagesCopy.length > 0) {
        log.log(this.state.pagesCopy);
        const playlist = this.state.pagesCopy.map((page) => page.id);
        let url = constants.base_url + `/courseware/api/course/${this.props.courseId}/reorder_pages/?format=json`;
      
        const reorderPages = async () => {
          try {
            await httpService.patch(url, { "playlist": JSON.stringify(playlist) });
            displayGlobalMessage('Successfully reordered the pages', 'success');
            // this.saveOrderSuccess('#sideList');
            this.setState({ pagesCopy: [] });
          } catch (error) {
            log.error(error);
          }
        };
      
        reorderPages();
      }
      this.setState({ order: false })
    }
  }

  render() {
    let { pages } = this.props;
    // const { activeLink } = this.state;

    return (
      <div>
        {/* <h6>Course Content</h6> k*/}
        <ul id="sideList" role="menu" aria-labelledby="dLabel">
          <li className="level-1">Course Content</li>
          <NavItem to={`/courseware/course/${this.props.courseId}/content/multimedia`} >
            <div className="d-flex link-div">Multimedia Book</div>
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/content/multimedia`}>
              <div className="d-flex link-div">Multimedia Book</div>
            </Link>
          </li> */}
          {/* <li
            className="level-2"
            onClick={() => this.handleClick("content")}
            id="sideList-content"
          >
            Assignments
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/content/labs`} >
            Labs
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/content/labs`}>
              <div className="d-flex link-div">Labs</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/content/about`}>
            About Course
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/content/about`}>
              <div className="d-flex link-div">About Course</div>
            </Link>
          </li> */}
          <hr />
          <li className="level-1">Interactions</li>
          <NavItem to={`/courseware/course/${this.props.courseId}/interactions/schedule`}>
            Schedule
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/interactions/schedule`}>
              <div className="d-flex link-div">Schedule</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/interactions/discussion-forum`} as={"anchor"}>
            Discussion Forum
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/interactions/discussion-forum`}>
              <div className="d-flex link-div">Discussion Forum</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/interactions/email-notices`}>
            Email Notices
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/interactions/email-notices`}>
              <div className="d-flex link-div">Email Notices</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/interactions/announcements`}>
            Course Announcements
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/interactions/announcements`}>
              <div className="d-flex link-div">Course Announcements</div>
            </Link>
          </li> */}
          {/* <li>Email + Archive</li>  Removed*/}
          <hr />
          <li className="level-1">Performance</li>
          {
            /* Should be in students view, hence moved there. */
            /* <li className="link-item">
              <Link className="link" to={`/courseware/course/${this.props.courseId}//performance/in_out_quizzes`}>
                <div className="d-flex link-div">In/out video quizzes</div>
              </Link>
            </li>*/
          }
          <NavItem to={`/courseware/course/${this.props.courseId}/performance/grades`} >
            Grades
          </NavItem>
          {/* <li className="link-item">
              <Link className="link" to={`/courseware/course/${this.props.courseId}/performance/grades`}>
                <div className="d-flex link-div">Grades</div>
              </Link>
            </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/performance/leaderboard`} >
            Leaderboard
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/performance/leaderboard`}>
              <div className="d-flex link-div">Leaderboard</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/performance/statistics`}>
            Statistics
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/performance/statistics`}>
              <div className="d-flex link-div">Statistics</div>
            </Link>
          </li> */}
          <hr />
          <li className="level-1">Course Management</li>
          <NavItem to={`/courseware/course/${this.props.courseId}/management/settings`}>
            Settings
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/management/settings`}>
              <div className="d-flex link-div">Settings</div>
            </Link>
          </li> */}
          <NavItem to={`/courseware/course/${this.props.courseId}/management/people`}>
            People
            {/* &nbsp;
            <span className="a_tooltip">
              &nbsp;{this.state.pending_students}&nbsp;
            </span> */}
          </NavItem>
          {/* <li className="link-item">
            <Link className="link" to={`/courseware/course/${this.props.courseId}/management/people`}>
              <div className="d-flex link-div">
                People &nbsp;{" "}
                <span className="a_tooltip">
                  {" "}
                  &nbsp;{this.state.pending_students} &nbsp;
                </span>
              </div>
            </Link>
          </li> */}

          <li className="level-1">Additional Pages</li>
          <li className="level-2">
            <Link className={`link`}
              to={`/courseware/course/${this.props.courseId}/pages/addpage`}>
              <Button
                variant="primary"
                id="sideList-add-page"
                className="btn border mr-2"
              >
                <IoAddCircleOutline size={18} className="mr-1" />
                Add Page
              </Button>
            </Link>
            <Button variant="light" className="btn border" onClick={() => this.handleAddionalPageReorder(pages)}>
              <MdImportExport color="#3f3f3f" size={20} />
              {this.state.order ? "Save" : ""}
            </Button>
          </li>
          <div id="additionalPages">
            {pages?.map((page) => (
              <NavItem pageID={page.id} key={page.id} to={{
                pathname: `/courseware/course/${this.props.courseId}/pages/${page.id}`,
                state: { page: page },
              }}>
                {page.title}
              </NavItem>
              // <li className="link-item">
              //   <Link className="link" to={{
              //     pathname: `/courseware/course/${this.props.courseId}/pages/${page.id}`, 
              //     state: { page : page },
              //       }}>
              //     <div className="d-flex link-div">{page.title}</div>
              //   </Link>
              // </li>
            ))}
          </div>


          {/* {page_order}
                    {pages} */}
        </ul>
      </div>
    );
  }
}